import { render, staticRenderFns } from "./GenericError.vue?vue&type=template&id=004a7119&scoped=true&"
import script from "./GenericError.vue?vue&type=script&lang=js&"
export * from "./GenericError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004a7119",
  null
  
)

export default component.exports